import { Link, useParams } from 'react-router-dom'
import { CmLawBrandBar } from '../../components/branding/CmLawBrandBar'

export default function IntakeSuccess() {
  const { token } = useParams<{ token: string }>()

  return (
    <div className="min-h-screen bg-slate-50">
      <CmLawBrandBar />
      <div className="flex flex-1 items-center justify-center px-4 py-10">
      <div className="max-w-md text-center rounded-xl border border-slate-200 bg-white p-8 shadow-sm">
        <h1 className="text-xl font-bold text-slate-900 mb-2">Thank you</h1>
        <p className="text-slate-600 mb-4">
          Your responses were received. Our team will review your information and follow up as needed.
        </p>
        <p className="text-xs text-slate-400">Reference: {token}</p>
        <Link to="/login" className="text-sm text-blue-600 hover:underline mt-4 inline-block">
          Return to CRM login
        </Link>
      </div>
      </div>
    </div>
  )
}
